import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import MDTypography from "../../../components/MDTypography";
import MDButton from "../../../components/MDButton"; // Assuming you're using Material Dashboard components

// eslint-disable-next-line react/prop-types
function CompleteOrder({ id, onDelivered }) {
  const [open, setOpen] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    if (deliveryDate) {
      onDelivered(id, deliveryDate);
      setDeliveryDate("");
      handleClose();
    }
  };

  return (
    <>
      <MDButton
        pl={2}
        variant="gradient"
        color="info"
        onClick={(e) => {
          e.preventDefault();
          handleOpen();
        }}
      >
        Delivered
      </MDButton>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Enter Expected Delivery Date</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Delivery Date"
            type="date"
            fullWidth
            value={deliveryDate}
            onChange={(e) => setDeliveryDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Cancel</MDButton>
          <MDButton onClick={handleConfirm} variant="gradient" color="info">
            Confirm
          </MDButton>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CompleteOrder;
